import { useRBA } from "./useRBA";
import type { PolicyPath } from "../Types";

export const usePermission = () => {
  const { isAllowed, checkAccess, isDenied, allowedRoles } = useRBA();

  const hasPermission = (permissionCode: string): boolean => {
    return isAllowed(permissionCode as PolicyPath);
  };

  const checkPermission = (permissionCode: string) => {
    return checkAccess(permissionCode as PolicyPath);
  };

  return { hasPermission, checkPermission, isDenied, allowedRoles };
};
